// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2-vjC","approved":"Status_approved__1Dh1c","rejected":"Status_rejected__1L1A8","expired":"Status_expired__wvl6z","label":"Status_label__1DECF"};